var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{staticStyle:{"margin":"2px","margin-bottom":"1rem"},attrs:{"size":"sm","type":"warning"},on:{"click":_vm.openGuide}},[_vm._v(_vm._s(_vm.$t('openguide')))])
}
var staticRenderFns = []

export { render, staticRenderFns }